import Main from '../components/landing/Main';

export default Main;